import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./Main/Main.component";
import { HomeComponent } from "./Pages/Home/Home.component";
import { ComingsoonComponent } from "./Pages/Session/ComingSoon/ComingSoon.component";
import { MaintenanceComponent } from "./Pages/Session/Maintenance/Maintenance.component";
import { LoginComponent } from "./Pages/Session/LogIn/LogIn.component";
import { Signup2Component } from "./Pages/Session/SignUp2/SignUp2.component";
import { GuardService as AuthGuard } from "./Services/Auth/guard.service";
import { PublicGuardService as PublicGuard } from "./Services/Auth/publicGuard.service";
import { CookiesComponent } from "./Pages/cookies/cookies.component";
import { ThankPageComponent } from "./Pages/thank-page/thank-page.component";
import { ThankPageBlogSuscriptionComponent } from "./Pages/thank-page-blog-suscription/thank-page-blog-suscription.component";


export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "",
    component: MainComponent,
    children: [
      {
        path: "home",
        component: HomeComponent,
        canActivate: [PublicGuard],
      },
      {
        path: "session/comingsoon",
        component: ComingsoonComponent,
        canActivate: [PublicGuard],
      },
      {
        path: "session/maintenance",
        component: MaintenanceComponent,
        canActivate: [PublicGuard],
      },
      {
        path: "login",
        component: LoginComponent,
        canActivate: [PublicGuard],
      },
      {
        path: "register",
        component: Signup2Component,
        canActivate: [PublicGuard],
      },
      {
        path: "blog",
        loadChildren: () =>
          import("./Pages/Blog/Blog.module").then((m) => m.BlogModule),
        canActivate: [PublicGuard],
      },
      {
        path: "cursos",
        loadChildren: () =>
          import("./Pages/Section/Section.module").then((m) => m.SectionModule),
        canActivate: [PublicGuard],
      },
      {
        path: "logged",
        loadChildren: () =>
          import("./Pages/HomeLogged/home-logged.module").then(
            (m) => m.HomeLoggedModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "courses",
        loadChildren: () =>
          import("./Pages/Courses/Courses.module").then((m) => m.CoursesModule),
        canActivate: [AuthGuard],
      },
      {
        path: "ebooks",
        loadChildren: () =>
          import("./Pages/ebooks/ebooks.module").then((m) => m.EbooksModule),
      },
      {
        path: "cookies",
        component: CookiesComponent,
        //canActivate: [PublicGuard]
      },
      {
        path: "thank-you-purchase",
        component: ThankPageComponent,
      },
      {
        path: "thank-you-blog-suscription",
        component: ThankPageBlogSuscriptionComponent,
      },
      {
        path: "**",
        redirectTo: "home",
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(AppRoutes, { anchorScrolling: "enabled" }),
  ],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
